import { makeStyles, createStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() =>
  createStyles({
    flexContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end",
      alignContent: "flex-end",
    },
    flexItem: {
      justifyContent: "flex-start",
      marginLeft: "13px",
      marginBlock: 5,
    },
    text: {
      color: "green",
      fontSize: "0px",
      marginLeft: "0px",
    },
    icon: {
      weight: "16vh",
      color: "green",
    },
    item: {
      marginRight: "0px",
      "&:hover": {
        background: "#C5E3C7",
      },
    },
  })
);
